import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalsComponent } from '../modals/modals.component';
import { IpsComponent } from '../ips/ips.component';
import { SettingsService } from '../services/settings.service';
import { MatSort, MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ActionsService } from '../services/actions.service';
import { Location } from '@angular/common';

export interface Ip {
  id:number;
  ip:string;
  created_at:any;
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  ips: any;
  id:number;
  add: boolean;
  edit: boolean;
  delete: boolean;
  invoice:string;
  proforma:string;
  debitno:string;
  kreditno:string;
  protocol:string;
  request:string;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private modalService: NgbModal,public dialog: MatDialog ,private actionService:ActionsService , private settingService: SettingsService,private _location:Location) {
    this.getIps();
    this.getActions();
    this.getSettings();
  }

  ngOnInit() {
  }

  submit(settingsForm){
    if(this.id == 0){
      this.settingService.saveSettings(settingsForm).subscribe(data=>window.location.reload());
    }else{
      this.settingService.updateSettings(this.id,settingsForm).subscribe(data=>window.location.reload());
    }
    
  }

  getActions() {
    this.actionService.moduleAction(12).subscribe(data => {
      if (data.watch_action == 1) {
        this.add = data.add_action;
        this.edit = data.edit_action;
        this.delete = data.delete_action;
      } else {
        this._location.back();
      }

    });
  }

  getSettings(){
    this.settingService.getSettings().subscribe(data => {
      this.id = data.id,
      this.invoice = data.invoice,
      this.proforma = data.proforma,
      this.kreditno = data.kreditno,
      this.debitno = data.debitno,
      this.protocol = data.protocol,
      this.request = data.request
    });
  }

  getIps() {
    this.settingService.getIps().subscribe(data =>{
      this.ips = data,
      console.log(data);
      this.displayedColumns = ['ip','created_at','actions']
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Ip>(this.ips);
      this.selection = new SelectionModel<Ip>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }


  deleteModal(id, component): void {
    console.log(id);
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      this.getIps();
  });
}

openDialog(id): void {
  if (id != 0) {
    this.settingService.editIp(id).subscribe(data1 => {
      const dialogRef = this.dialog.open(IpsComponent, {
        width: '600px',
        data: {
          ip: data1.ip,
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result != undefined) {
          this.settingService.updateIp(result, id).subscribe(data => {
            this.getIps();
          });
        }
      });
    });
  } else {
    const dialogRef = this.dialog.open(IpsComponent, {
      width: '600px',
      data: {
        ip: '',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.settingService.saveIp(result).subscribe(data => {
          this.getIps();
        });
      }
    });
  }
}

}
